import template from './project-details.html';
import controller from './project-details.controller';

let projectDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default projectDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/project-details.component.js